const DocumentIcon = (props) => {
  return (
    <svg viewBox='0 0 24 24'>
      <path
        d='M4 7h16M4 12h16M4 17h10'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        {...props}
      />
    </svg>
  );
};

export default DocumentIcon;
